function menu_open() {
    $('.burger_button-js').click(function(){
        $('.menu_burger').toggleClass('menu_burger_open');
        $('body').toggleClass('menu_burger_open');
        return false;
    });
};

function initSmoothScroll() {
    const header = document.querySelector('header');

    function checkScroll() {
        const scrollPosition = window.scrollY;
        if (scrollPosition > 50) {
            header.classList.add('scrolled-js');
        } else {
            header.classList.remove('scrolled-js');
        }
    }

    // Vérifie au chargement
    checkScroll();

    // Vérifie à chaque scroll
    window.addEventListener('scroll', checkScroll);
};

function showMore() {
    const buttons = document.querySelectorAll('.values_item_button-js');
    buttons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();

            const parentLink = button.closest('.values_item');
            if (parentLink) {
                parentLink.classList.add('active');
            }
        });
    });
};

function initCircleSlider(swiperSelector, paginationSelector) {
    new Swiper(swiperSelector, {
        loop: true,
        grabCursor: true,
        centeredSlides: false,
        centeredSlidesBounds: true,
        pagination: { 
            el: paginationSelector,
            clickable: true,
        },
        // navigation: {
        //     nextEl: ".circle_slider__control--next",
        //     prevEl: ".circle_slider__control--prev"
        // },
        slidesPerView: 3,
        effect: "creative",
        creativeEffect: {
            perspective: true,
            limitProgress: 3,
            prev: {
                translate: ["-90%", "20%", -100],
                rotate: [0, 0, -20],
                origin: "bottom"
            },
            next: {
                translate: ["90%", "20%", -100],
                rotate: [0, 0, 20],
                origin: "bottom"
            }
        }
    });
};

doAnimations = function () {
    var n = $(window).scrollTop() + $(window).height(),
        e = $(".animatable-js");
    0 == e.length && $(window).off("scroll", doAnimations),
        e.each(function (e) {
            var t = $(this);
            t.offset().top + t.height() - 20 < n && t.removeClass("animatable-js").addClass("animated-js");
    });
};

function removeAnimationFirst() {
    const banners = document.querySelectorAll('.banner');

    banners.forEach(banner => {
        const nextElement = banner.nextElementSibling;

        if (nextElement && (nextElement.tagName === 'DIV' || nextElement.tagName === 'SECTION')) {
            // Sélectionne tous les éléments qui ont au moins une classe animatable
            const animatables = nextElement.querySelectorAll('[class*="animatable-"], .animatable-js');

            animatables.forEach(el => {
                // Copie les classes dans un tableau pour éviter les problèmes en supprimant en boucle
                Array.from(el.classList).forEach(cls => {
                    if (cls === 'animatable-js' || cls.startsWith('animatable-')) {
                    el.classList.remove(cls);
                    }
                });
            });
        }
    });
}

function postsFitler() {
    const buttons = document.querySelectorAll('.post_filter_btn-js');
    const posts = document.querySelectorAll('.post_link-js');

    buttons.forEach(btn => {
        btn.addEventListener('click', () => {
            buttons.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');

            const filter = btn.dataset.filter;

            posts.forEach(p => {
                if (filter === 'all' || p.classList.contains(filter)) {
                    p.classList.add('post_active-js');
                } else {
                    p.classList.remove('post_active-js');
                }
            });
        });
    });
};

/* Begin Sauce filter data send */
function getFilters(tax) {
    const pills = document.querySelectorAll(
        '.filter-pill[data-tax="' + tax + '"].is-active'
    );

    // Intensité = cumulatif côté UI. On ne garde que le niveau le plus élevé.
    if (tax === 'intensity') {
        let maxLevel = 0;
        let maxSlug = null;
        pills.forEach(p => {
            const lvl = Number(p.dataset.level || 0);
            if (lvl > maxLevel) {
                maxLevel = lvl;
                maxSlug = p.dataset.term;
            }
        });
        return maxSlug ? [maxSlug] : [];
    }

    return Array.from(pills).map(p => p.dataset.term);
}

function sauce_data_send() {
    const form = document.getElementById('gform_5');
    const input = document.querySelector('#input_5_4');
    const openBtn = document.getElementById('send-filters-js');

    if (openBtn) {
        openBtn.addEventListener('click', function () {
            const wrapper = document.getElementById('filter-wrapper-form');
            wrapper?.classList.remove('d-none');
            wrapper?.classList.add('block');
        });
    }

    if (!form || !input) return;

    form.addEventListener('submit', function () {
        const filters = {
            gammes: getFilters('gammes'),
            types: getFilters('types'),
            intensity: getFilters('intensity'),
            usages: getFilters('usages'),
            conditionnement: getFilters('conditionnement'),
            ethniques: getFilters('ethniques'),
            sectors: getFilters('sectors'),
        };

        input.value = JSON.stringify(filters);
    }, true); // capture phase important pour GF
}
/* End Sauce filter data send */


/* Begin label private */
function privatelabel() {
    const root = document.querySelector(".component_privatelabel");
    if (!root) return;

    const title       = root.querySelector("#activeTitle");
    const description = root.querySelector("#activeDescription");

    // Lecture des valeurs initiales depuis les boutons actifs (slugs PHP)
    let activePackaging = root.querySelector(".variant-button[data-packaging].is-active")?.dataset.packaging ?? null;
    let activeSauce     = root.querySelector(".variant-button[data-sauce].is-active")?.dataset.sauce ?? null;

    function updateImage() {
        root.querySelectorAll(".product-image").forEach(img => img.classList.remove("is-visible"));
        root.querySelector(
            `.product-image[data-packaging="${activePackaging}"][data-sauce="${activeSauce}"]`
        )?.classList.add("is-visible");
    }

    function updateLayer() {
        root.querySelectorAll(".info-layer").forEach(l => l.classList.remove("is-active"));
        root.querySelector(`.info-layer[data-sauce="${activeSauce}"]`)?.classList.add("is-active");
    }

    function updateButtons() {
        root.querySelectorAll(".variant-button[data-packaging]").forEach(b => {
            b.classList.toggle("is-active", b.dataset.packaging === activePackaging);
        });
        root.querySelectorAll(".variant-button[data-sauce]").forEach(b => {
            b.classList.toggle("is-active", b.dataset.sauce === activeSauce);
        });
    }

    function updateCaption() {
        if (!title || !description) return;
        const sauceBtn = root.querySelector(`.variant-button[data-sauce="${activeSauce}"]`);
        if (sauceBtn) {
            title.textContent       = sauceBtn.dataset.title;
            description.textContent = sauceBtn.dataset.description;
        }
    }

    root.addEventListener("click", (e) => {
        const button = e.target.closest(".variant-button");
        if (button) {
            const { packaging, sauce } = button.dataset;
            if (packaging !== undefined) activePackaging = packaging;
            if (sauce     !== undefined) activeSauce     = sauce;

            updateImage();
            updateLayer();
            updateButtons();
            updateCaption();
        }

        const bubble = e.target.closest(".info-bubble");
        if (bubble) bubble.classList.toggle("is-open");
    });

    // Init
    updateImage();
    updateLayer();
    updateButtons();
    updateCaption();
}
/* End private label */ 


/* Begin loadmore */
function fetchSaucePage(page) {
    return fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
            action: 'load_more_sauces',
            page: page
        })
    }).then(response => response.text());
}

function loadMoreProducts() {
    // Le bouton existe en double dans le DOM (une version mobile, une desktop) :
    // on les pilote comme un seul groupe avec une page partagée pour rester synchros.
    const buttons = Array.from(document.querySelectorAll('.js-load-more'));
    const container = document.querySelector('#js-products');
    if (!buttons.length || !container) return;

    let currentPage = Number(buttons[0].dataset.page) || 1;
    let isLoadingAll = false;
    let hasMore = true;

    const setLoading = (loading) => buttons.forEach(btn => btn.classList.toggle('is-loading', loading));
    const syncPage = (page) => {
        currentPage = page;
        buttons.forEach(btn => { btn.dataset.page = page; });
    };
    const removeButtons = () => {
        hasMore = false;
        buttons.forEach(btn => btn.remove());
    };

    buttons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            if (isLoadingAll || !hasMore) return;
            const page = currentPage + 1;
            const maxPages = Number(container.dataset.maxPages);
            setLoading(true);
            fetchSaucePage(page).then(html => {
                container.insertAdjacentHTML('beforeend', html);
                syncPage(page);
                if (page >= maxPages) {
                    removeButtons();
                }
                setLoading(false);
                document.dispatchEvent(new CustomEvent('sauce:products-loaded'));
            });
        });
    });

    // Dès qu'un filtre est activé, on charge le reste du catalogue en tâche
    // de fond (une page à la fois, comme un lazy load) pour que le filtre
    // porte sur toutes les sauces et pas seulement sur les 15 déjà affichées.
    document.addEventListener('sauce:need-all-products', () => {
        if (!hasMore || isLoadingAll) return; // plus rien à charger, ou déjà en cours

        isLoadingAll = true;
        setLoading(true);
        const maxPages = Number(container.dataset.maxPages);

        function loadNext() {
            const page = currentPage + 1;
            fetchSaucePage(page).then(html => {
                container.insertAdjacentHTML('beforeend', html);
                syncPage(page);
                document.dispatchEvent(new CustomEvent('sauce:products-loaded'));

                if (page >= maxPages) {
                    isLoadingAll = false;
                    removeButtons();
                } else {
                    loadNext();
                }
            });
        }

        loadNext();
    });
}
/* End loadmore */


document.addEventListener("DOMContentLoaded", () => {
    menu_open();
    initSmoothScroll();
    showMore();
    postsFitler();
    sauce_data_send();
    removeAnimationFirst();
    privatelabel();
    loadMoreProducts();

    // Initialisation des deux sliders
    initCircleSlider(".team_circle_slider__swiper-js", ".team_circle_slider__pagination-js");
    initCircleSlider(".testimonials_circle_slider__swiper-js", ".testimonials_circle_slider__pagination-js");
});
$(window).on("scroll", function () {
    doAnimations()
})